'use client'

import cn from 'clsx'
import type { LenisOptions } from 'lenis'
import { usePathname } from 'next/navigation'
import { type ComponentProps, useEffect } from 'react'

import type { Theme } from '~/styles/config'
import { Canvas } from '~/webgl/components/canvas'
import { Lenis } from '../lenis'
import { Navigation } from '../navigation'

interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  theme?: Theme
  lenis?: boolean | LenisOptions
  webgl?: boolean | Omit<ComponentProps<typeof Canvas>, 'children'>
}

export function Wrapper({
  children,
  theme = 'blue',
  className,
  lenis = true,
  webgl,
  ...props
}: WrapperProps) {
  const pathname = usePathname()

  // biome-ignore lint/correctness/useExhaustiveDependencies: we need to trigger on path change
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
  }, [pathname, theme])

  return (
    <div className="bg-primary">
      <div className="max-w-[1440px] mx-auto dt:dr-border-l-5 dt:dr-border-t-0 dt:dr-border-b-0 dt:dr-border-r-5 dt:border-solid border-[#DADADA] floating-container">
        <div className="w-full  dt:dr-border-l-10 dt:dr-border-t-0 dt:dr-border-b-0 dt:dr-border-r-10 dt:border-solid border-secondary">
          {webgl && <Canvas root {...(typeof webgl === 'object' && webgl)} />}
          <Navigation />
          <main
            className={cn('relative flex flex-col grow', className)}
            {...props}
          >
            {children}
            <script>
              {`document.documentElement.setAttribute('data-theme', '${theme}');`}
            </script>
          </main>
          {lenis && (
            <Lenis root options={typeof lenis === 'object' ? lenis : {}} />
          )}
        </div>
      </div>
    </div>
  )
}
